import { generateId } from '../../../shared/lib/id';
import type { Room } from '../model/types';
import { parseSafeNumber } from '@/shared/lib/number';
import i18n from '@/shared/config/i18n/i18n';

/**
 * Фабрика для создания объекта комнаты.
 */
export const createRoom = (id?: string, name: string = '', options: Partial<Room> = {}): Room => {
  return {
    id: id || generateId(),
    name: name,
    dims: { 
      length: parseSafeNumber(options.dims?.length, 0), 
      width: parseSafeNumber(options.dims?.width, 0), 
      height: parseSafeNumber(options.dims?.height, 0) 
    },
    openings: options.openings || [],
    partitions: options.partitions || [],
    wallElements: options.wallElements || [],
    items: options.items || []
  };
};

/**
 * Валидация данных комнаты перед сохранением или расчетом.
 */
export const validateRoom = (room: Room): { valid: boolean; error?: string } => {
  if (!room.name) return { valid: false, error: i18n.t('room.validation.name_required', 'Имя комнаты обязательно') };
  
  const l = parseSafeNumber(room.dims.length);
  const w = parseSafeNumber(room.dims.width);
  
  if (l <= 0 || w <= 0) {
      return { valid: false, error: i18n.t('room.validation.dimensions_positive', 'Размеры должны быть положительными') };
  }
  return { valid: true };
};
